import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AdminRoute({ children }) {
  const { loading, currentUser, isAdmin } = useAuth();

  if (loading) return <div className="route-fallback">Checking admin access…</div>;
  if (!currentUser) return <Navigate to="/auth" replace />;
  if (!isAdmin) return <Navigate to="/profile" replace />;

  return children;
}
